var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenuDonation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2C12.7909 2 11 3.79086 11 6C11 8.20914 12.7909 10 15 10C17.2091 10 19 8.20914 19 6C19 3.79086 17.2091 2 15 2ZM9 6C9 2.68629 11.6863 0 15 0C18.3137 0 21 2.68629 21 6C21 9.31371 18.3137 12 15 12C11.6863 12 9 9.31371 9 6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 11H2C2.65362 11 3.73343 11.1279 4.80987 11.4735C5.71141 11.763 6.74184 12.2471 7.47997 13.055H10C11.335 13.055 12.6096 13.6001 13.5451 14.5613C13.6807 14.7008 13.8077 14.8473 13.9256 15H18.838C19.7834 15 20.6092 15.4601 21.1871 15.8881C21.8679 16.3922 22.3728 17.1002 22.6352 17.9087L23.2618 19.8423L10.8335 23.772C9.5981 24.1622 8.2636 24.0481 7.11008 23.4553C7.11001 23.4552 7.11016 23.4553 7.11008 23.4553L0 19.803V11ZM14.8683 17C14.9552 17.3792 15 17.77 15 18.165V19.165H7V17.165H12.8407C12.6922 16.7121 12.4439 16.2975 12.1118 15.9562C11.547 15.3759 10.7868 15.055 10 15.055H6.47142L6.1737 14.6182C5.81311 14.0892 5.09512 13.6657 4.19838 13.3778C3.32457 13.0972 2.45138 13 2 13V18.5819L8.02392 21.6762C8.71016 22.029 9.49965 22.0959 10.2305 21.865C10.2306 21.865 10.2304 21.8651 10.2305 21.865L20.7382 18.5426L20.7328 18.5261C20.7328 18.5259 20.7329 18.5262 20.7328 18.5261C20.5969 18.1074 20.3376 17.7476 19.9969 17.4954C19.5533 17.1669 19.1518 17 18.838 17H14.8683Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4V8H14V4H16Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuDonation);
export default __webpack_public_path__ + "static/media/icon_menu_donation.2642c35d.svg";
export { ForwardRef as ReactComponent };